export default "__VITE_ASSET__CFMke6zq__"